// Document templates

export const TEMPLATES = [
  {
    id: 'photography-services',
    title: 'Photography Services Agreement',
    description: 'Professional contract covering services, payment, delivery, and copyright',
    icon: '📄',
    template: (data) => `PHOTOGRAPHY SERVICES AGREEMENT

This Photography Services Agreement ("Agreement") is entered into between ${data.business_name || '[BUSINESS_NAME]'} ("Photographer"), located at ${data.full_address || '[ADDRESS]'}, and ${data.client_name || '[CLIENT_NAME]'} ("Client").

SERVICES
Photographer agrees to provide photography services as described and agreed upon at the time of booking. The specific date, time, location, and deliverables will be confirmed in writing prior to the session.

PAYMENT
A non-refundable retainer of 50% of the total session fee is due at booking to reserve the date. The remaining balance is due 48 hours before the session. Session fees are non-refundable once paid.

CANCELLATION & RESCHEDULING
Client may reschedule once at no charge with at least 7 days notice. Cancellations with less than 48 hours notice forfeit the retainer. Photographer reserves the right to reschedule in the event of illness, emergency, or severe weather.

IMAGE DELIVERY
Edited images will be delivered via an online gallery within the timeframe agreed upon at booking. The number of edited images delivered is at Photographer's professional discretion.

COPYRIGHT & USAGE
Photographer retains full copyright of all images. Client is granted a personal use license for printing and sharing. Images may not be sold, used commercially, or altered without written permission. Photographer reserves the right to use images for portfolio, website, and social media unless Client requests otherwise in writing prior to the session.

PHOTOGRAPHER'S LIMITATION OF LIABILITY
In the unlikely event that Photographer is unable to perform services due to illness, injury, or circumstances beyond their control, liability is limited to a full refund of all payments received. Photographer is not liable for circumstances beyond their control including but not limited to equipment failure, inclement weather, or third-party actions.

MODEL RELEASE
Unless a separate written objection is provided, Client grants Photographer permission to use session images for promotional purposes including website, social media, and print portfolios.

GOVERNING LAW
This Agreement shall be governed by the laws of the State of ${data.state_of_operation || '[STATE]'}.

By proceeding with this booking, Client acknowledges they have read, understood, and agree to the terms of this Agreement.

Photographer: ${data.photographer_name || '[PHOTOGRAPHER_NAME]'} / ${data.business_name || '[BUSINESS_NAME]'}
Date: ${data.date_signed || '[DATE_SIGNED]'}

Client Signature: _______________________
Client Printed Name: ____________________
Date: __________________________________`
  },
  {
    id: 'model-release',
    title: 'Model Release',
    description: 'Permission for portfolio and promotional use of session images',
    icon: '✍️',
    template: (data) => `MODEL RELEASE

I, ${data.client_name || '[CLIENT_NAME]'} ("Model"), hereby grant ${data.business_name || '[BUSINESS_NAME]'} and photographer ${data.photographer_name || '[PHOTOGRAPHER_NAME]'} ("Photographer") the irrevocable right and permission to use, reproduce, publish, and distribute photographs taken on the session date for the following purposes:

✓ Portfolio and promotional materials
✓ Website and social media
✓ Print advertising and editorial use
✓ Exhibition and competition entry

I understand that:
- I will receive no compensation for this usage
- I waive any right to inspect or approve finished photographs
- This release is binding on my heirs and assigns
- I may request exclusion of specific images in writing within 14 days of gallery delivery

MINOR RELEASE (complete if model is under 18):
I am the parent or legal guardian of the minor named above and consent to the above on their behalf.

Guardian Name: ________________________
Relationship: __________________________
Guardian Signature: ____________________

---

Model Signature: _______________________
Printed Name: __________________________
Date: __________________________________

Witnessed by: ${data.photographer_name || '[PHOTOGRAPHER_NAME]'} / ${data.business_name || '[BUSINESS_NAME]'}
${data.full_address || '[ADDRESS]'}`
  },
  {
    id: 'liability-waiver',
    title: 'Liability Waiver',
    description: 'Release and assumption of risk for photography sessions',
    icon: '⚠️',
    template: (data) => `PHOTOGRAPHY SESSION LIABILITY WAIVER

Client Name: ${data.client_name || '[CLIENT_NAME]'}
Photographer: ${data.photographer_name || '[PHOTOGRAPHER_NAME]'} / ${data.business_name || '[BUSINESS_NAME]'}
Session Date: ${data.session_date || '[SESSION_DATE]'}

ASSUMPTION OF RISK
I understand that photography sessions may take place in various locations including outdoor environments, private property, and urban settings. I voluntarily assume all risks associated with participation in the session.

RELEASE OF LIABILITY
I hereby release and hold harmless ${data.business_name || '[BUSINESS_NAME]'}, ${data.photographer_name || '[PHOTOGRAPHER_NAME]'}, and any assistants from any claims, damages, losses, or expenses arising from participation in this photography session, including but not limited to personal injury, property damage, or accidents.

PROPERTY & WARDROBE
I accept full responsibility for any personal property, wardrobe, or props brought to the session. Photographer is not liable for lost, stolen, or damaged personal items.

LOCATION COMPLIANCE
I agree to comply with all rules and regulations of any location used during the session. If a location requires permits or fees, these are the responsibility of the Client unless otherwise agreed in writing.

MEDIA CONSENT
I consent to being photographed and to the resulting images being used as described in any accompanying Photography Services Agreement or Model Release.

Client Signature: _______________________
Printed Name: __________________________
Date: __________________________________

${data.business_name || '[BUSINESS_NAME]'}
${data.full_address || '[ADDRESS]'}
${data.photographer_name || '[PHOTOGRAPHER_NAME]'}`
  }
];

export function fillTemplate(templateId, businessProfile, clientName) {
  const template = TEMPLATES.find(t => t.id === templateId);
  if (!template) return '';

  const fullAddress = [
    businessProfile.street_address,
    businessProfile.city,
    businessProfile.state,
    businessProfile.zip_code
  ].filter(Boolean).join(', ');

  const data = {
    business_name: businessProfile.business_name,
    photographer_name: businessProfile.photographer_name,
    full_address: fullAddress,
    state_of_operation: businessProfile.state_of_operation,
    client_name: clientName,
    date_signed: new Date().toLocaleDateString(),
    session_date: '[SESSION_DATE]'
  };

  return template.template(data);
}
